
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype3Off as ObiMosfetNtype3OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-3-off.js';
 
 
 

 
 export const ObiMosfetNtype3Off = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-3-off',
   elementClass: ObiMosfetNtype3OffElement,
   events: {
     
   }
  });
 
 